export default __webpack_public_path__ + "OpenSans-LightItalic-0e63c9e707bdfbcda3077baa43a7484a.ttf";